import React from 'react'
import Link from 'next/link'
import { THEME } from 'utils'

const PartnershipsCTAButton = ({
  className,
  link,
  text,
  color = '#141e30',
  backgroundColor = '#ffffff',
  borderColor = '#141e30'
}) => (
  <>
    <Link href={link}>
      <a className={'ctaButton ' + className} style={{ color, backgroundColor, borderColor }}>
        {text}
      </a>
    </Link>
    <style jsx>{`
      .ctaButton {
        margin: 0;
        font-family: HelveticaNeue;
        font-weight: bold;
        border: 1px solid;
        cursor: pointer;
        text-align: center;
        font-size: 2.25vw;
        padding: 1.25% 0.5%;
        width: 20vw;
      }
      .partnershipsCarousel__cta {
        margin: 2% 0 3%;
      }
      .verticalsIndex__cta {
        position: absolute;
        left: 8%;
        bottom: 8%;
      }
      .secondaryGrid__cta {
        margin: 2% 0;
        font-size: 2.75vw;
      }
      .indexPanel__cta {
        display: block;
        border-radius: 4px;
        padding: 0.4rem;
        margin: 0 auto;
        font-size: 3.5vw;
        width: 30vw;
      }
      @media (min-width: 370px) {
        .ctaButton {
          font-size: 2.1vw;
          padding: 1.25% 0.5%;
          width: 21vw;
          border: 2px solid;
        }
        .partnershipsCarousel__cta {
          margin: 1.5% 0 2.5%;
        }
        .secondaryGrid__cta {
          font-size: 2.75vw;
        }
        .indexPanel__cta {
          border-radius: 4px;
          padding: 0.4rem;
          font-size: 3.5vw;
          width: 32vw;
        }
      }
      @media (min-width: 400px) {
      }
      @media (min-width: ${THEME.BREAKPOINTS.XS}px) {
        .ctaButton {
          font-size: 1.8vw;
          padding: 1.25% 0.5%;
          width: 17vw;
        }
        .partnershipsCarousel__cta {
          margin: 1.5% 0 2.5%;
        }
        .secondaryGrid__cta {
          font-size: 2.25vw;
        }
        .indexPanel__cta {
          padding: 1.4%;
          font-size: 3.25vw;
          width: 28vw;
        }
      }
      @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
        .ctaButton {
          font-size: 1.05vw;
          padding: 0.75% 0.5%;
          width: 11vw;
        }
        .partnershipsCarousel__cta {
          margin: 1% 0 2%;
        }
        .verticalsIndex__cta {
          left: 12%;
          bottom: 10%;
          font-size: 1.1vw;
          padding: 0.65% 0;
          width: 10.5vw;
        }
        .secondaryGrid__cta {
          font-size: 1.25w;
          padding: 1.75% 0.5%;
          width: 25%;
        }
        .indexPanel__cta {
          padding: 1%;
          font-size: 1.8vw;
          width: 14vw;
        }
      }
      @media (min-width: ${THEME.BREAKPOINTS.MD}px) {
        .secondaryGrid__cta {
          width: 26%;
        }
        .indexPanel__cta {
          padding: 1%;
          font-size: 1.8vw;
          width: 14vw;
        }
      }
      @media (min-width: ${THEME.BREAKPOINTS.LG}px) {
      }
      @media (min-width: ${THEME.BREAKPOINTS.XL}px) {
        .ctaButton {
          font-size: 0.8rem;
          padding: 0.4rem 0.2rem;
          width: 132px;
        }
        .verticalsIndex__cta {
          font-size: 0.82rem;
          width: 125px;
        }
        .partnershipsCarousel__cta {
          margin: 1% 0 2%;
        }
        .secondaryGrid__cta {
          font-size: 0.8rem;
          padding: 1.75% 0.5%;
          width: 110px;
        }
        .indexPanel__cta {
          padding: 1%;
          font-size: 1.4rem;
          width: 168px;
        }
      }
    `}</style>
  </>
)

export default PartnershipsCTAButton
